
    import {defineComponent,  ref} from 'vue'
    import inicio from '@/services/home/home.service'
    import politicas from "@/services/politicas/politicas.service";

    export default  defineComponent({ 
        components: {
        // 'AppMenu': AppMenu,
            
        },  

        setup() {
            // Servicios
            const servInicio = ref(new inicio());
            const servPoliticas = new politicas();

            // Variables                 
            const arr_imagesJson=ref(null)       
            const arreglo_imgs = ref([
                require('../assets/images/001.jpg'),
                require('../assets/images/002.jpg'),
                require('../assets/images/003.jpg'),
                require('../assets/images/004.jpg'),
                require('../assets/images/005.jpg'),
                require('../assets/images/006.jpg')
            ]);
            const presentacion = ref(null);

            return { 
                servInicio,
                arr_imagesJson,
                arreglo_imgs, 
                imagen: arreglo_imgs.value[0],
                indice: 1,
                servPoliticas,
                presentacion
            }
        },           
        methods: {
            VerDifusion(){                                
                window.location.href = process.env.VUE_APP_URL_DIFUSION;
            },

            CargarImagen(){
                this.indice++

                if (this.indice == this.arreglo_imgs.length){
                    this.indice = 0
                }

                this.imagen = this.arreglo_imgs[this.indice]
                this.$forceUpdate();
            }, 

            leerArchivoImagenes() {
            this.servInicio.getArchivoIMG().then(response => {                  
                    this.arr_imagesJson = response[0].Elementos    
                } )           
            },
            cargarDatos() {
                this.servPoliticas.getPoliticas().then(response => {
                    const resultado = response.data
                    this.presentacion = resultado.find((item) => item.id == 0)
                    //console.log('texto_presentacion:', this.presentacion)
                })
            }
        },

        mounted(){
                        
            setInterval(() => {
                this.CargarImagen()                
            }, 6000)

            this.leerArchivoImagenes()
            this.cargarDatos()
        }

        
    }); 


